"use strict";

var _toConsumableArray = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.range = function (n) {
  return _toConsumableArray(Array(n).keys());
};

exports.flatten = function (array) {
  var _ref;

  return (_ref = []).concat.apply(_ref, _toConsumableArray(array));
};

exports.replaceObjectInArray = function (list, entity, index, valuesToReplace) {
  return [].concat(_toConsumableArray(list.slice(0, index)), [entity.merge(valuesToReplace)], _toConsumableArray(list.slice(index + 1)));
};

exports.updateObjectInArray = function (array, object) {
  var isEqual = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (item) {
    return item.id === object.id;
  };
  var index = array.findIndex(isEqual);
  return index >= 0 ? array.slice(0, index).concat(object).concat(array.slice(index + 1)) : array;
};

exports.updateOrAddObjectInArray = function (array, object) {
  var isEqual = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (item) {
    return item.id === object.id;
  };
  var index = array.findIndex(isEqual);
  return index >= 0 ? array.slice(0, index).concat(object).concat(array.slice(index + 1)) : array.concat(object);
};

exports.validateArray = function (minValue) {
  return function (val) {
    return val && val.length >= minValue && minValue > 0 ? undefined : 'ERROR';
  };
};

exports.reducerAccumulator = function (accumulator, currentValue) {
  return accumulator + currentValue;
};

exports.isEmpty = function (array) {
  return !array || array.length === 0;
};

exports.autocompleteWithNumbers = function (x, y) {
  return x > y ? [] : [x].concat(_toConsumableArray(exports.autocompleteWithNumbers(x + 1, y)));
};

exports.intersect = function () {
  var _exports;

  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var xArr = args[0];
  var yArr = args[1];
  var rest = args.slice(2);
  if (!yArr) return xArr;
  var zArr = xArr.filter(function (x) {
    return yArr.includes(x);
  });
  return (_exports = exports).intersect.apply(_exports, [zArr].concat(_toConsumableArray(rest)));
};

var ARRAY_UTILS = {
  range: exports.range,
  flatten: exports.flatten,
  replaceObjectInArray: exports.replaceObjectInArray,
  updateObjectInArray: exports.updateObjectInArray,
  updateOrAddObjectInArray: exports.updateOrAddObjectInArray,
  validateArray: exports.validateArray,
  reducerAccumulator: exports.reducerAccumulator,
  isEmpty: exports.isEmpty,
  autocompleteWithNumbers: exports.autocompleteWithNumbers,
  intersect: exports.intersect
};
exports.default = ARRAY_UTILS;